var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6872 12.8167C15.6615 12.8167 14.6691 12.65 13.7434 12.35C13.4516 12.25 13.1263 12.325 12.9012 12.55L11.5919 14.1917C9.23183 13.0667 7.02189 10.9417 5.84604 8.5L7.47222 7.11667C7.69738 6.88333 7.7641 6.55833 7.67237 6.26667C7.36381 5.34167 7.20536 4.35 7.20536 3.325C7.20536 2.875 6.83009 2.5 6.37976 2.5H3.49434C3.04401 2.5 2.50195 2.7 2.50195 3.325C2.50195 11.0667 8.94829 17.5 16.6872 17.5C17.2793 17.5 17.5128 16.975 17.5128 16.5167V13.6417C17.5128 13.1917 17.1376 12.8167 16.6872 12.8167Z",
    fill: "#4B475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallVerification);
export default __webpack_public_path__ + "static/media/call_verification.ed2db388bbbc22170490c70c648c95f6.svg";
export { ForwardRef as ReactComponent };